import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withKeys as _withKeys, vModelSelect as _vModelSelect, withModifiers as _withModifiers, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-a1a724f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "conection"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "orange" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-heart-broken" }),
  /*#__PURE__*/_createTextVNode(" Estableciendo Conexión ")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "spin"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "modal"
}
const _hoisted_8 = { class: "contenedor" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Consulta", -1))
const _hoisted_10 = { class: "contenido" }
const _hoisted_11 = { class: "contenido" }
const _hoisted_12 = {
  key: 2,
  class: "modal7"
}
const _hoisted_13 = { class: "contenedor7" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Productos", -1))
const _hoisted_15 = { class: "contenido7" }
const _hoisted_16 = { class: "contenido7" }
const _hoisted_17 = { id: "customers" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Referencia"),
  /*#__PURE__*/_createElementVNode("th", null, "Lote"),
  /*#__PURE__*/_createElementVNode("th", null, "Cantidad")
], -1))
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "general" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Información General")
], -1))
const _hoisted_22 = { class: "grid" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "barcode"
}, "Código Barra:", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "division"
}, "División:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "lineaGrupo"
}, "Línea / Grupo:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "present"
}, "Presentación:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "desc"
}, "Descripción:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "uniMed"
}, "Empaque:", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Unidad", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Paquete", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Caja", -1))
const _hoisted_32 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "equiv"
}, "Equivalencia:", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "ref"
}, "Referencia:", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "vence"
}, "Vencimiento:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "lote"
}, "Lote:", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "farmaco"
}, "Fármaco:", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Orígen del Producto")
], -1))
const _hoisted_39 = { class: "grid" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fab"
}, "Fabricante:", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "supdr"
}, "Suplidor:", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "regInd"
}, "Registro Industrial:", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "regSan"
}, "Registro Sanitario:", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Existencia")
], -1))
const _hoisted_45 = { class: "grid" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "almacn"
}, "Almacén:", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "subAlmacn"
}, "Sub Almacén:", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "cant"
}, "Cantidad:", -1))
const _hoisted_49 = { class: "grid-consultas" }
const _hoisted_50 = { style: {"font-weight":"bold"} }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["disabled"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Guardar ")
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = ["disabled"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Actualizar ")
const _hoisted_61 = [
  _hoisted_59,
  _hoisted_60
]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Eliminar ")
const _hoisted_64 = [
  _hoisted_62,
  _hoisted_63
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_Navbar),
      (_ctx.conectando)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
        : _createCommentVNode("", true),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (_ctx.cargando)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.showModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (this.showModalMethod())),
                  for: "btn-modal"
                }, "X"),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("textarea", {
                      rows: "12",
                      id: "showInComentary",
                      type: "showInComentary",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentEdition.description) = $event)),
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.currentEdition.description]
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showModal7)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (this.showModalMethod7())),
                  for: "btn-modal"
                }, "X"),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("table", _hoisted_17, [
                    _hoisted_18,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productos, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        onClick: ($event: any) => (_ctx.redirect(item._id))
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.ref), 1),
                        _createElementVNode("td", null, _toDisplayString(item.lote), 1),
                        _createElementVNode("td", null, _toDisplayString(item.cant), 1)
                      ], 8, _hoisted_19))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_20, [
        _createElementVNode("form", null, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.encabezado), 1),
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", null, [
                _hoisted_23,
                _withDirectives(_createElementVNode("input", {
                  id: "barcode",
                  onKeypress: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.changeFocus()), ["enter"])),
                  type: "barcode",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.producto.barcode) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.producto.barcode]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_24,
                _withDirectives(_createElementVNode("input", {
                  id: "division",
                  type: "division",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.producto.division) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.producto.division]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_25,
                _withDirectives(_createElementVNode("input", {
                  id: "lineaGrupo",
                  type: "lineaGrupo",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.producto.lineaGrupo) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.producto.lineaGrupo]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_26,
                _withDirectives(_createElementVNode("input", {
                  id: "present",
                  type: "present",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.producto.present) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.producto.present]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_27,
                _withDirectives(_createElementVNode("input", {
                  id: "desc",
                  type: "desc",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.producto.desc) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.producto.desc]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_28,
                _withDirectives(_createElementVNode("select", {
                  id: "uniMed",
                  type: "uniMed",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.producto.uniMed) = $event)),
                  class: "form-select"
                }, _hoisted_32, 512), [
                  [_vModelSelect, _ctx.producto.uniMed]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_33,
                _withDirectives(_createElementVNode("input", {
                  id: "equiv",
                  type: "Number",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.producto.equiv) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.producto.equiv]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_34,
                _withDirectives(_createElementVNode("input", {
                  id: "ref",
                  type: "ref",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.producto.ref) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.producto.ref]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_35,
                _withDirectives(_createElementVNode("input", {
                  id: "vence",
                  type: "month",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.producto.vence) = $event)),
                  class: "form-control",
                  onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.calcVenc(_ctx.producto.vence)))
                }, null, 544), [
                  [_vModelText, _ctx.producto.vence]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_36,
                _withDirectives(_createElementVNode("input", {
                  id: "lote",
                  type: "lote",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.producto.lote) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.producto.lote]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_37,
                _withDirectives(_createElementVNode("input", {
                  id: "farmaco",
                  type: "farmaco",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.producto.farmaco) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.producto.farmaco]
                ])
              ])
            ]),
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", null, [
                _hoisted_40,
                _withDirectives(_createElementVNode("input", {
                  id: "fab",
                  type: "fab",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.producto.fab) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.producto.fab]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_41,
                _withDirectives(_createElementVNode("input", {
                  id: "supdr",
                  type: "supdr",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.producto.supdr) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.producto.supdr]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_42,
                _withDirectives(_createElementVNode("input", {
                  id: "regInd",
                  type: "regInd",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.producto.regInd) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.producto.regInd]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_43,
                _withDirectives(_createElementVNode("input", {
                  id: "regSan",
                  type: "regSan",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.producto.regSan) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.producto.regSan]
                ])
              ])
            ]),
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", null, [
                _hoisted_46,
                _withDirectives(_createElementVNode("select", {
                  id: "almacn",
                  type: "almacn",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.producto.almacn) = $event)),
                  class: "form-select",
                  onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.defSubs()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.almacenes, (almacen, index) => {
                    return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(almacen.desc), 1))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.producto.almacn]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_47,
                _withDirectives(_createElementVNode("select", {
                  id: "subAlmacn",
                  type: "subAlmacn",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.producto.subAlmacn) = $event)),
                  class: "form-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subs, (sub, index) => {
                    return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(sub), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.producto.subAlmacn]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_48,
                _withDirectives(_createElementVNode("input", {
                  id: "cant",
                  type: "Number",
                  min: "0",
                  step: "1",
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.producto.cant) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.producto.cant]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.producto.consultas, (consulta, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "card-body"
                }, [
                  _createElementVNode("p", _hoisted_50, [
                    _createTextVNode(" No. " + _toDisplayString(index + 1) + " - " + _toDisplayString(_ctx.newFormatDate(consulta.date)) + " ", 1),
                    _createElementVNode("i", {
                      onClick: _withModifiers(($event: any) => (_ctx.deleteService(index)), ["prevent"]),
                      style: {"cursor":"pointer"},
                      class: "fas fa-minus-circle redOption"
                    }, null, 8, _hoisted_51),
                    _hoisted_52,
                    _createElementVNode("i", {
                      onClick: _withModifiers(($event: any) => (_ctx.editService(index, consulta)), ["prevent"]),
                      style: {"cursor":"pointer"},
                      class: "fas fa-edit greenOption"
                    }, null, 8, _hoisted_53)
                  ]),
                  _createElementVNode("p", null, _toDisplayString(consulta.description), 1)
                ]))
              }), 128))
            ]),
            (this.modoForm == 'add')
              ? _withDirectives((_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary",
                  onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.saveProducto()), ["prevent"])),
                  disabled: 
                !_ctx.producto.fecha ||
                  !_ctx.producto.division ||
                  !_ctx.producto.lineaGrupo ||
                  !_ctx.producto.present ||
                  !_ctx.producto.uniMed ||
                  !_ctx.producto.equiv ||
                  !_ctx.producto.desc ||
                  !_ctx.producto.ref ||
                  !_ctx.producto.vence ||
                  !_ctx.producto.mesVenc ||
                  !_ctx.producto.anoVenc ||
                  !_ctx.producto.lote ||
                  !_ctx.producto.barcode ||
                  !_ctx.producto.farmaco ||
                  !_ctx.producto.fab ||
                  !_ctx.producto.supdr ||
                  !_ctx.producto.regInd ||
                  !_ctx.producto.regSan ||
                  !_ctx.producto.almacn ||
                  !_ctx.producto.cant
              
                }, _hoisted_57, 8, _hoisted_54)), [
                  [_vShow, !this.conectando]
                ])
              : _createCommentVNode("", true),
            (this.modoForm == 'show')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-success",
                  onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.handleUpdate()), ["prevent"])),
                  disabled: 
                !_ctx.producto.fecha ||
                  !_ctx.producto.division ||
                  !_ctx.producto.lineaGrupo ||
                  !_ctx.producto.present ||
                  !_ctx.producto.uniMed ||
                  !_ctx.producto.equiv ||
                  !_ctx.producto.desc ||
                  !_ctx.producto.ref ||
                  !_ctx.producto.vence ||
                  !_ctx.producto.mesVenc ||
                  !_ctx.producto.anoVenc ||
                  !_ctx.producto.lote ||
                  !_ctx.producto.barcode ||
                  !_ctx.producto.farmaco ||
                  !_ctx.producto.fab ||
                  !_ctx.producto.supdr ||
                  !_ctx.producto.regInd ||
                  !_ctx.producto.regSan ||
                  !_ctx.producto.almacn ||
                  !_ctx.producto.cant
              
                }, _hoisted_61, 8, _hoisted_58))
              : _createCommentVNode("", true),
            (_ctx.showDelete)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-danger",
                  onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (_ctx.handleDelete()), ["prevent"]))
                }, _hoisted_64))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.cargando]
      ])
    ])
  ]))
}